export default "__VITE_ASSET__9c799644__"